(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-choose"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.am-choose .am-ccard').forEach(function (card) {
        var sum = card.querySelector('.am-cbar-sum');
        var edit = card.querySelector('.am-cbar-edit');
        var dot = card.querySelector('.am-cbar-dot');
        var txt = card.querySelector('.am-cbar-txt');
        var change = card.querySelector('.am-cbar-change');
        var done = card.querySelector('.am-cbar-done');
        function refresh() {
          var sz = card.querySelector('.am-szb.on');
          var col = card.querySelector('.am-cdot.on');
          txt.textContent = 'Size ' + (sz ? sz.textContent.trim() : 'M');
          if (col) dot.style.background = col.style.background;
        }
        if (change) change.addEventListener('click', function () { sum.hidden = true; edit.hidden = false; });
        if (done) done.addEventListener('click', function () { refresh(); edit.hidden = true; sum.hidden = false; });
        card.querySelectorAll('.am-szb').forEach(function (b) {
          b.addEventListener('click', function () {
            card.querySelectorAll('.am-szb').forEach(function (x) { x.classList.remove('on'); });
            b.classList.add('on');
          });
        });
        card.querySelectorAll('.am-cdot').forEach(function (d) {
          d.addEventListener('click', function () {
            card.querySelectorAll('.am-cdot').forEach(function (x) { x.classList.remove('on'); });
            d.classList.add('on');
          });
        });
      });
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-engineered"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.am-eng').forEach(function (root) {
        var dataEl = root.querySelector('.am-eng-data');
        var stage = root.querySelector('.am-ghost-stage');
        var img = root.querySelector('.am-ghost-img');
        var card = root.querySelector('.am-ghost');
        var callout = root.querySelector('.am-callout');
        if (!dataEl || !stage || !callout) return;
        var cfg;
        try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
        var hss = root.querySelectorAll('.am-hs');
        var cTitle = callout.querySelector('h4');
        var cDesc = callout.querySelector('p');
        var cThumb = callout.querySelector('.am-c-thumb');
        var cBadge = callout.querySelector('.am-c-badge');

        function placeCallout(dot) {
          var gw = stage.clientWidth, gh = stage.clientHeight;
          var dx = parseFloat(dot.style.left) / 100 * gw;
          var dy = parseFloat(dot.style.top) / 100 * gh;
          var wide = dot.dataset.layout === 'wide';
          callout.classList.toggle('wide', wide);
          var cw = Math.min(wide ? 260 : 190, gw - 16);
          callout.style.width = cw + 'px';
          var dir = dot.dataset.dir || (dy < gh * 0.52 ? 'down' : 'up');
          callout.classList.remove('arr-up', 'arr-down', 'arr-left', 'arr-right');
          callout.style.top = 'auto'; callout.style.bottom = 'auto';
          callout.style.left = 'auto'; callout.style.right = 'auto';
          var gap = 16;
          if (dir === 'down' || dir === 'up') {
            var cx = Math.max(8, Math.min(dx - cw / 2, gw - cw - 8));
            callout.style.left = cx + 'px';
            callout.style.setProperty('--ax', (dx - cx) + 'px');
            if (dir === 'down') { callout.style.top = (dy + gap) + 'px'; callout.classList.add('arr-up'); }
            else { callout.style.bottom = (gh - dy + gap) + 'px'; callout.classList.add('arr-down'); }
          } else {
            var ch = wide ? 152 : 130;
            var cy = Math.max(8, Math.min(dy - ch / 2, gh - ch - 8));
            callout.style.top = cy + 'px';
            callout.style.setProperty('--ay', (dy - cy) + 'px');
            if (dir === 'left') { callout.style.left = Math.max(8, dx - gap - cw) + 'px'; callout.classList.add('arr-right'); }
            else { callout.style.left = Math.min(dx + gap, gw - cw - 8) + 'px'; callout.classList.add('arr-left'); }
          }
        }
        function hideCallout() { callout.classList.remove('show'); hss.forEach(function (x) { x.classList.remove('active'); }); }
        function showHs(b) {
          hss.forEach(function (x) { x.classList.remove('active'); });
          b.classList.add('active');
          cTitle.textContent = b.dataset.t; cDesc.textContent = b.dataset.d;
          if (b.dataset.img) { cThumb.src = b.dataset.img; cThumb.style.display = 'block'; } else { cThumb.style.display = 'none'; }
          if (b.dataset.badge) { cBadge.textContent = b.dataset.badge; cBadge.classList.add('show'); } else { cBadge.classList.remove('show'); cBadge.textContent = ''; }
          placeCallout(b); callout.classList.add('show');
        }
        hss.forEach(function (b) {
          b.addEventListener('click', function (e) { e.stopPropagation(); showHs(b); });
        });
        document.addEventListener('click', function (e) {
          if (callout.classList.contains('show') && !e.target.closest('.am-hs')) hideCallout();
        });
        root.querySelectorAll('.am-tt-opt').forEach(function (b) {
          b.addEventListener('click', function () {
            root.querySelectorAll('.am-tt-opt').forEach(function (x) { x.classList.remove('active'); });
            b.classList.add('active');
            var tee = cfg[b.dataset.tee];
            if (!tee) return;
            img.style.backgroundImage = "url('" + tee.img + "')";
            if (tee.bg) card.style.background = tee.bg;
            card.classList.toggle('am-h', b.dataset.tee === 'h');
            hss.forEach(function (d) {
              var k = d.dataset.key;
              if (tee[k]) { d.style.top = tee[k].p[0] + '%'; d.style.left = tee[k].p[1] + '%'; d.dataset.img = tee[k].img; }
            });
            hideCallout();
          });
        });
        window.addEventListener('resize', function () { var a = root.querySelector('.am-hs.active'); if (a) placeCallout(a); });
      });
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-feeding"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.am-feed').forEach(function (root) {
        var vid = root.querySelector('.am-feed-vid');
        if (!vid) return;
        root.querySelectorAll('.am-tt-opt').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (!btn.dataset.src) return;
            root.querySelectorAll('.am-tt-opt').forEach(function (x) { x.classList.remove('active'); });
            btn.classList.add('active');
            vid.src = btn.dataset.src;
            vid.play();
          });
        });
      });
    }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-header"]) return;
  try {
    
  (function () {
    function init() {
      var menu = document.querySelector('[data-am-menu]');
      if (!menu) return;
      function open() { menu.hidden = false; requestAnimationFrame(function () { menu.classList.add('open'); }); }
      function close() { menu.classList.remove('open'); setTimeout(function () { menu.hidden = true; }, 340); }
      document.querySelectorAll('[data-am-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
      document.querySelectorAll('[data-am-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
      menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      document.querySelectorAll('.am-seals').forEach(function(seals){
        var segs=seals.querySelectorAll('.am-mseg');
        if(!segs.length)return;
        function frame(){
          var r=seals.getBoundingClientRect(), cx=r.left+r.width/2, half=r.width/2||1;
          for(var i=0;i<segs.length;i++){
            var sr=segs[i].getBoundingClientRect();
            var d=Math.min(1,Math.abs((sr.left+sr.width/2)-cx)/half), t=1-d;
            segs[i].style.transform='scale('+(0.66+t*0.5).toFixed(3)+')';
            segs[i].style.opacity=(0.22+t*0.78).toFixed(3);
          }
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }
    if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.am-revsec').forEach(function (root) {
        var modal = root.querySelector('.am-rev-modal');
        if (!modal) return;
        var rmText = modal.querySelector('.am-rm-text');
        var rmBy = modal.querySelector('.am-rm-by');
        var rmPhotos = modal.querySelector('.am-rm-photos');
        function openCard(card) {
          rmText.textContent = '“' + (card.getAttribute('data-full') || '') + '”';
          var nm = card.getAttribute('data-name') || '';
          var sz = card.getAttribute('data-size') || '';
          var loc = card.getAttribute('data-loc') || '';
          rmBy.innerHTML = '<b>' + nm + '</b>' + (sz ? ' · wears ' + sz : '') + (loc ? ' · ' + loc : '');
          var imgs = (card.getAttribute('data-imgs') || '').split(',').filter(Boolean);
          rmPhotos.innerHTML = imgs.map(function (s) { return '<span class="am-rc-ph" style="background-image:url(\'' + s + '\')"></span>'; }).join('');
          rmPhotos.style.display = imgs.length ? 'flex' : 'none';
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
        }
        function close() { modal.hidden = true; document.body.style.overflow = ''; }
        root.querySelectorAll('.am-rc-exp').forEach(function (b) {
          b.addEventListener('click', function () { openCard(b.closest('.am-revcard')); });
        });
        modal.querySelectorAll('[data-close]').forEach(function (e) { e.addEventListener('click', close); });
      });
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestseller-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBsp(root) {
    var rail = root.querySelector('.bsp__rail');
    if (!rail) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.bsp-card'));
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('is-active'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          cards.forEach(function (c) { c.classList.remove('is-active'); });
          e.target.classList.add('is-active');
        }
      });
    }, { root: rail, rootMargin: '0px -45% 0px -45%', threshold: 0 });
    cards.forEach(function (c) { io.observe(c); });
  }
  function boot() {
    document.querySelectorAll('.bsp').forEach(initBsp);
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.bsp') : null;
    if (root) initBsp(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-launch-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.alhv2').forEach((hero) => {
  const stage = hero.querySelector('[data-stage]');
  const dots = hero.querySelectorAll('[data-go]');
  if (stage && dots.length) {
    let raf = null;
    stage.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const w = stage.clientWidth;
        if (!w) return;
        const idx = Math.round(stage.scrollLeft / w);
        dots.forEach((d, i) => d.classList.toggle('alhv2__dot--active', i === idx));
      });
    }, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = Number(dot.dataset.go) || 0;
        stage.scrollTo({ left: stage.clientWidth * idx, behavior: 'smooth' });
      });
    });
  }

  // Dynamic-island scroll trigger: fire as soon as the user scrolls past
  // the very top of the page, not after the whole hero clears the viewport.
  // On scroll, row 1 of the header gains a white bg (see allomoms-brand.css)
  // while row 2 (the wordmark pill) stays transparent — only the pill
  // floats over the page content.
  const onScroll = () => {
    document.body.classList.toggle('scrolled-past-hero', window.scrollY > 20);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
